<script setup>
import { formatDate } from '@/utils/dateUtils';
//import { ref} from 'vue';
//import ArgonButton from "@/components/ArgonButton.vue";

const ProductOffers = defineModel();
// function goToStore() {
//     window.open('https://prezentowaprzystan.pl/Admin/Product/Create', '_blank');
// }

const props = defineProps({
    selectedProductOffer: Object,
    sortBy: String,
    sortDesc: Boolean
});

const emit = defineEmits([
    'select',
    'sort-changed'
]);

function editOffer(offer) {

    emit("select", offer);

    document
        .getElementById("EditParameters")
        ?.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
}

function sort(field) {

    let desc = true;

    if (props.sortBy === field) {
        desc = !props.sortDesc;
    }

    emit('sort-changed', {
        field,
        desc
    });
}

</script>
<template>
  <div class="card">
    <!-- <div class="card-header pb-0">
      <div class="row">
        <div class="col-12">
          <div class="d-flex align-items-center">
            <h6 class="mb-0">Product Offers:</h6>
            <argon-button color="dark" variant="gradient"  size="sm" class="ms-auto" @click="goToStore"><i class="fas fa-plus me-2"></i>Add New Product </argon-button>
          </div>
        </div>
      </div>
    </div> -->
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2" @click="sort('Id')">
                Id
                <span v-if="sortBy === 'Id'" :class="{'text-danger': sortDesc,'text-success': !sortDesc}">{{ sortDesc ? '▼' : '▲' }}</span>
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" @click="sort('ProductName')">
                Product
                <span v-if="sortBy === 'ProductName'" :class="{'text-danger': sortDesc,'text-success': !sortDesc}">{{ sortDesc ? '▼' : '▲' }}</span>
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" @click="sort('ProductVariant')">
                ProductVariant
                <span v-if="sortBy === 'ProductVariant'" :class="{'text-danger': sortDesc,'text-success': !sortDesc}">{{ sortDesc ? '▼' : '▲' }}</span>
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" @click="sort('OfferName')">
                Offer
                <span v-if="sortBy === 'OfferName'" :class="{'text-danger': sortDesc,'text-success': !sortDesc}">{{ sortDesc ? '▼' : '▲' }}</span>
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" @click="sort('OfferPrice')">
                Price
                <span v-if="sortBy === 'OfferPrice'" :class="{'text-danger': sortDesc,'text-success': !sortDesc}">{{ sortDesc ? '▼' : '▲' }}</span>
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" @click="sort('OfferHandlingTime')">
                Delivery
                <span v-if="sortBy === 'OfferHandlingTime'" :class="{'text-danger': sortDesc,'text-success': !sortDesc}">{{ sortDesc ? '▼' : '▲' }}</span>
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" @click="sort('CreatedDate')">
                CreatedDate
                <span v-if="sortBy === 'CreatedDate'" :class="{'text-danger': sortDesc,'text-success': !sortDesc}">{{ sortDesc ? '▼' : '▲' }}</span>
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" @click="sort('UpdatedDate')">
                UpdatedDate
                <span v-if="sortBy === 'UpdatedDate'" :class="{'text-danger': sortDesc,'text-success': !sortDesc}">{{ sortDesc ? '▼' : '▲' }}</span>
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" @click="sort('Published')">
                Status
                <span v-if="sortBy === 'Published'" :class="{'text-danger': sortDesc,'text-success': !sortDesc}">{{ sortDesc ? '▼' : '▲' }}</span>
              </th>
              <!-- <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Allegro</th> -->
            </tr>
          </thead>
          <tbody>
              <tr v-for="Product in ProductOffers" :key="Product.Id"   :class="{'table-primary':props.selectedProductOffer?.Id === Product.Id}" @click="editOffer(Product)"> 
              <td>
                <div class="d-flex px-2 py-1">
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ Product.Id }}</h6>
                    <p class="text-xs text-secondary mb-0">
                      
                    </p>
                    <p class="text-xs text-secondary mb-0"></p>
                    <div class="image-preview" @click.stop>
                      <img
                          :src="Product.ImageUrl" height="75"
                          class="image-thumb"
                      >
                      <!-- <div class="image-popup"> -->
                      <div class="image-preview-modal">
                          <img
                              :src="Product.ImageUrl"
                              class="image-large"
                          >
                      </div>
                    </div>
                  </div>
                </div>
              </td>
              <td class="align-middle text-center">
                <p class="text-sm text-center font-weight-bold mb-0">{{ Product.ProductName }}</p>
                <p class="text-sm text-center text-secondary mb-0">
                  {{ Product.ProductId }}
                  <a class="btn btn-link text-info px-3 mb-0" :href="'/products?productId='+Product.ProductId"  v-if="!Product.Deleted&&Product.ProductId" @click.stop><i class="fas fa-eye me-2" aria-hidden="true"></i>View</a>
                </p>
                  
                    
                  
                  <!-- <div class="image-preview">
                    <img
                        :src="Product.Images[0]" height="75"
                        class="image-thumb"
                    >
                    <div class="image-popup">
                        <img
                            :src="Product.Images[0]"
                            class="image-large"
                        >
                    </div>
                  </div> -->
              </td>
              <td class="align-middle text-center text-sm">
                <h6 class="mb-0 text-sm">{{ Product.ProductVariant }}</h6>
               
              </td>
              
              <td class="align-middle text-center">
                  <p class="text-sm font-weight-bold mb-0" v-if="Product.OfferId">{{ Product.OfferName }}</p>
                  <p class="text-sm font-weight-bold mb-0 text-warning" v-else>{{ Product.OfferName }}</p>

                  <p class="text-sm font-weight-bold text-secondary mb-0">
                    {{ Product.OfferId }}  
                    <span v-if="Product.OfferId">
                      <a class="btn btn-link text-info px-3 mb-0" :href="'https://allegro.pl/oferta/'+Product.OfferId" target="_blank" v-if="!Product.Deleted && Product.IsPublished" @click.stop><i class="fas fa-eye me-2" aria-hidden="true"></i>View</a>
                      <a class="btn btn-link text-secondary px-3 mb-0" :href="'https://salescenter.allegro.com/offer/'+Product.OfferId+'/edit'" target="_blank" v-if="!Product.Deleted" @click.stop><i class="fas fa-pencil me-2" aria-hidden="true"></i>Edit</a>
                    </span>
                  </p>
                  
                 
              </td>
              <td class="align-middle text-center text-sm">
                <h6 class="mb-0 text-sm">{{ Product.OfferPrice }} {{ Product.OfferCurrency }}</h6>
                <!-- <h6 class="mb-0 text-sm">{{ Product.Offer_SellingMode_Format }}</h6> -->
              </td>
               <td class="align-middle text-center text-sm">
                <h6 class="mb-0 text-sm">{{ Product.OfferHandlingTime }} </h6>
                
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold"
                  >{{ formatDate(Product.CreatedDate) }}</span
                >
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold"
                  >{{ formatDate(Product.UpdatedDate) }}</span
                >
              </td>
              <td class="align-middle text-center">
                <span class="badge badge-sm bg-gradient-success" v-if="Product.IsPublished">{{ Product.PublicationStatus }}</span>
                <span class="badge badge-sm bg-gradient-secondary" v-else>{{ Product.PublicationStatus}}</span>
              </td>
              <!--<td class="align-middle text-center" style="z-index: 100;">
                 <a
                  :href="'/product/'+Product.Id"
                  class="text-secondary font-weight-bold text-xs"
                  data-toggle="tooltip"
                  data-original-title="Edit user"
                  >Edit</a
                > 
               
              </td>-->
            </tr>
            
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

